
<h1 id="title" class="title">Se te olvidó tu contraseña</h1>
<p class="sub-title">Ingrese su dirección de correo electrónico</p>

<nb-alert *ngIf="errors && !success && !submitted" outline="danger" role="alert">
  <p class="alert-title"><b>Error!</b></p>
  <ul class="alert-message-list">
    <li  class="alert-message">No existe el correo electrónico </li>
  </ul>
</nb-alert>

<nb-alert *ngIf="!errors && success  && !submitted" outline="success" role="alert">
  <p class="alert-title"><b>Exito!</b></p>
  <ul class="alert-message-list">
    <li  class="alert-message">Se ha enviado los accesos al correo registrado</li>
  </ul>
</nb-alert>

<form [formGroup]="requestPasswordForm" [nbSpinner]="loading" nbSpinnerStatus="success" nbSpinnerSize="giant">

    <div class="form-control-group">
        <label for="input-email">Correo electrónico:</label>
        <input  nbInput
                autofocus
                fullWidth
                fieldSize="large"
                id="input-email"
                formControlName="email"
                [status]="email.dirty ? (email.invalid  ? 'danger' : 'success') : ''"
                [attr.aria-invalid]="email.invalid && email.touched ? true : null"
                placeholder="Correo electrónico">
        <ngx-validation-message label="Correo electrónico" [showPattern]="email?.hasError('pattern') && email.touched"
          [showRequired]="email?.errors?.required && email.touched"></ngx-validation-message>
      </div>


  <button nbButton
          fullWidth
          status="primary"
          size="large"
          [disabled]="submitted || !requestPasswordForm.valid"
          [class.btn-pulse]="submitted"
          (click) = "requestPass()">
    
Solicitar contraseña
  </button>
</form>

<section class="sign-in-or-up" aria-label="Sign in or sign up">
  <p><a class="text-link" routerLink="../login">Volver a iniciar sesión</a></p>
 
</section>

